import { Node_Type } from 'ricos-schema';

var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
const getParagraphTextAlignment = (node) => {
  var _a, _b;
  return (_b = (_a = node == null ? void 0 : node.paragraphData) == null ? void 0 : _a.textStyle) == null ? void 0 : _b.textAlignment;
};
const listItemConverter = {
  toTiptap: {
    types: [Node_Type.LIST_ITEM],
    convert: (node, visit) => {
      var _a;
      const paragraphNode = (_a = node == null ? void 0 : node.nodes) == null ? void 0 : _a[0];
      const textAlignment = getParagraphTextAlignment(paragraphNode);
      return {
        type: Node_Type.LIST_ITEM,
        attrs: __spreadProps(__spreadValues({}, textAlignment ? { textStyle: { textAlignment } } : {}), {
          id: node.id
        }),
        content: visit(node)
      };
    }
  },
  fromTiptap: {
    types: [Node_Type.LIST_ITEM],
    convert: (node, visit) => {
      const { attrs = {} } = node;
      const { id } = attrs;
      return {
        type: Node_Type.LIST_ITEM,
        id,
        nodes: visit(node)
      };
    }
  }
};

export { listItemConverter };
//# sourceMappingURL=list-converters.js.map
